<template>

  <!-- Overlay Start -->
  <div class="overlay"></div>
  <!-- Overlay End -->

  <!-- Page Banner Start -->
  <div class="section page-banner">

    <!-- <img class="shape-1 animation-round" src="/assets/images/shape/shape-8.png" alt="Shape"> -->

    <img class="shape-2" src="/assets/images/shape/shape-23.png" alt="Shape">

    <div class="container">
      <!-- Page Banner Start -->
      <div class="page-banner-content">
        <ul class="breadcrumb">
          <li><a href="#">Home</a></li>
          <li class="active">Contact Us</li>
        </ul>
        <h2 class="title">Contact <span>Us</span></h2>
      </div>
      <!-- Page Banner End -->
    </div>

    <!-- Shape Icon Box Start -->
    <div class="shape-icon-box">

      <img class="icon-shape-1 animation-left" src="/assets/images/shape/shape-5.png" alt="Shape">

      <div class="box-content">
        <div class="box-wrapper">
          <i class="flaticon-badge"></i>
        </div>
      </div>

      <img class="icon-shape-2" src="/assets/images/shape/shape-6.png" alt="Shape">

    </div>
    <!-- Shape Icon Box End -->

    <img class="shape-3" src="/assets/images/shape/shape-24.png" alt="Shape">

    <img class="shape-author" src="/assets/images/author/author-11.jpg" alt="Shape">

  </div>
  <!-- Page Banner End -->

  <!-- Contact Start -->
  <div class="section section-padding padding-top-0">
    <div class="container">

      <!-- Contact Wrapper Start -->
      <div class="contact-wrapper">
        <div class="row align-items-center">
          <div class="col-lg-6">

            <!-- Contact Info Start -->
            <div class="contact-info">

              <img class="shape animation-round" src="/assets/images/shape/shape-12.png" alt="Shape">


              <!-- Single Contact Info End -->
              <!-- Single Contact Info Start -->
              <div class="single-contact-info">
                <div class="info-icon">
                  <i class="flaticon-email"></i>
                </div>
                <div class="info-content">
                  <h6 class="title">Email Address.</h6>
                  <p class="font-size-14"><a :href="'mailto:' + support_email">{{support_email}}</a></p>
                </div>
              </div>
              <!-- Single Contact Info End -->
              <!-- Single Contact Info Start -->
              <div class="single-contact-info">
                <div class="info-icon">
                  <i class="flaticon-pin"></i>
                </div>
                <div class="info-content">
                  <h6 class="title">Office Address.</h6>
                  <p>47 Knoll Drive, London, England, N14 5LU</p>
                </div>
              </div>
              <!-- Single Contact Info End -->
            </div>
            <!-- Contact Info End -->

          </div>
          <div class="col-lg-6">

            <!-- Contact Form Start -->
            <div class="contact-form">
              <h3 class="title">Get in Touch <span>With Us</span></h3>

              <div class="form-wrapper">
                <form id="contact-form" @submit.prevent='send_msg'>
                  <!-- Single Form Start -->
                  <div class="single-form">
                    <input type="text" v-model="form.name" placeholder="Name">
                  </div>
                  <!-- Single Form End -->
                  <!-- Single Form Start -->
                  <div class="single-form">
                    <input type="email" v-model="form.email" placeholder="Email">
                  </div>
                  <!-- Single Form End -->
                  <!-- Single Form Start -->
                  <div class="single-form">
                    <input type="text" v-model="form.subject" placeholder="Subject">
                  </div>
                  <!-- Single Form End -->
                  <!-- Single Form Start -->
                  <div class="single-form">
                    <textarea v-model="form.message" placeholder="Message"></textarea>
                  </div>
                  <!-- Single Form End -->
                  <p class="form-message"></p>
                  <!-- Single Form Start -->
                  <div class="single-form">
                    <button class="btn btn-primary btn-hover-dark w-100">
                      <span>Send Message</span>
                      <div v-if='loader' class="loader"></div>
                      <i v-else class="flaticon-right"></i>
                    </button>
                  </div>
                  <div class="single-form" v-if='message'>
                    {{message}}
                  </div>
                  <!-- Single Form End -->
                </form>
              </div>
            </div>
            <!-- Contact Form End -->

          </div>
        </div>
      </div>
      <!-- Contact Wrapper End -->

    </div>
  </div>
  <!-- Contact End -->

</template>

<script>
import {AppConfig} from '@/constants';
import api from '@/services/api'
export default {
  name: 'Contact',
  data(){
    return{
      support_email: null,
      loader: false,
      form: {},
      message: null
    }
  },
  mounted() {
      this.support_email = AppConfig.SUPPORT_EMAIL;
  },
  methods:{
    async send_msg(){
      this.loader = true;
      try{
        let res = await api.post(`/user/contact`, this.form , {
             requiresAuth: false
        });
        
        this.message = res.data.message;
        this.form = {};
        
      }catch (error) {
        console.log(error);
        this.message = error.response.data.error;
      }finally{
        this.loader = false;
      }
    }
  },
};
</script>
<style scoped>
button .loader {
  display: inline-block;
  margin-left: 8px; /* optional spacing between span and loader */
  vertical-align: middle;
}

.loader {
  width: 20px;
  aspect-ratio: 1;
  border-radius: 50%;
  border: 4px solid white;
  border-right-color: #309255;
  animation: l2 1s infinite linear;
}
@keyframes l2 {to{transform: rotate(1turn)}}
</style>
